import gql from 'graphql-tag';

/**
 * @param orderId optional order ID
 */
export const CTGLoyaltyIssuePoints = gql`
  mutation ctgLoyaltyIssuePoints(
    $loyaltyId: String!
    $loyaltyUserCognitoId: String!
    $points: Int!
    $reason: String!
    $orderId: String
    $comments: String
  ) {
    ctgLoyaltyIssuePoints(
      loyaltyId: $loyaltyId
      loyaltyUserCognitoId: $loyaltyUserCognitoId
      points: $points
      reason: $reason
      orderId: $orderId
      comments: $comments
    )
  }
`;
